// extracted by mini-css-extract-plugin
module.exports = {"card_cat_filters":"CatFilters_card_cat_filters__2DpjY","active":"CatFilters_active__38By5"};